module.exports = __webpack_public_path__ + "img/102050.557267de.png";